import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const body = document.body;
    body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  return (
    <div className="App">
      <nav className="navbar">
        <ul className="nav-links">
          <li><a href="https://github.com/b-tao">GitHub</a></li>
          <li><a href="https://linkedin.com/in/b-tao">LinkedIn</a></li>
        </ul>
        <button className="mode-toggle" onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? 'Light Mode' : 'Dark Mode'}
        </button>
      </nav>
      <header className="App-header">
        <h1>Welcome!</h1>
        <p>This is my portfolio website. My name is Brian Tao and I'm a medical student at Boston University, where I also completed my undergraduate studies in computer science and medicine. I have experience in both fields and like to explore the intersection of both.</p>
      </header>
    </div>
  );
}

export default App;
